import React from 'react';
import Calculator from './components/Calculator';


function App() {
  return (
    <div >
      <Calculator />
    </div>
  );
}

export default App;
